const HTML_RESPONSE_PATTERN = /^\s*(?:<!doctype\s+html|<html|<br\s*\/?|<b>)/i;

const getResponseDescription = (response, body) => {
  const contentType = response.headers.get("content-type") || "";
  const trimmedBody = body.trim();

  if (HTML_RESPONSE_PATTERN.test(trimmedBody) || contentType.includes("text/html")) {
    return "The server returned an HTML error page instead of API data.";
  }

  return "The server returned an invalid API response.";
};

/**
 * Parse an API response without leaking PHP/HTML errors into JSON.parse.
 * The returned error is suitable for the UI while the short response preview
 * remains available in development diagnostics.
 */
export const parseJsonResponse = async (response) => {
  const body = await response.text();

  if (!body.trim()) {
    throw new Error(`The server returned an empty response (${response.status}).`);
  }

  try {
    return JSON.parse(body);
  } catch (cause) {
    const description = getResponseDescription(response, body);
    const preview = body.replace(/\s+/g, " ").trim().slice(0, 180);
    const error = new Error(`${description} Please refresh and try again.`);
    error.cause = cause;
    error.status = response.status;
    error.responsePreview = preview;
    throw error;
  }
};
